<ng-template #classic let-c="close" let-d="dismiss">
    <div class="modal-content">
        <div class="d-flex justify-content-end">
            <span data-dismiss="modal" (click)="modalReference.close(false)">
                <i class="material-icons">close</i>
            </span>
        </div>
        <div class="d-flex flex-column align-items-center">
            <div class="modal-title" id="modal-title-default">
                {{ title }}
            </div>
            <div class="m-3">
                <i class="material-icons warning">warning</i>
            </div>
            <div class="text-center mb-3">
                {{ message }}
            </div>
        </div>
        <div class="d-flex justify-content-center">
            <button type="button" class="modal-ok-btn" ngbAutofocus (click)="modalReference.close(true)">
                {{ 'CONSTANTS.BTN_OK' | translate | uppercase }} </button>
        </div>
    </div>
</ng-template>